module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0096.jpg?v=1099d117";